import { ConnectedProps, connect } from "react-redux";
import { actions as loginActions } from "../../../reducers/login";
import * as yup from "yup";
import { VALIDATION_REGEX } from "utils/constants";
import EmailRestore from "./EmailRestore";
import { EmailContainer } from "./types";
import { AppDispatch, RootState } from "store";
import { EmailType } from "sagas/types/login";
import i18next from "config/i18next";
import { sessionSelector } from "reducers/session";

const EmailRestoreContainer = (
  props: EmailContainer & ConnectorProps
): JSX.Element => {
  const validationSchema: yup.SchemaOf<EmailType> = yup.object({
    email: yup
      .string()
      .required(i18next.t("validations:required"))
      .matches(
        VALIDATION_REGEX.regEmail,
        i18next.t("validations:invalidEmailFormat")
      ),
  });

  const onSubmit = (values: EmailType) => {
    props.postLoginEmail(values);
  };

  return (
    <EmailRestore
      {...props}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      testId="forgot-password"
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  isFetching: sessionSelector(state).fetching,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  postLoginEmail: (params: EmailType) => {
    dispatch(loginActions.getLoginEmailRequest(params));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(EmailRestoreContainer);
